import { IFormBasicInfo } from 'legacy/lut/features/partner360/basicInfo'
import { createContext } from 'react'

export const BasicInfoSaveContext = createContext<
  ((changes: Partial<IFormBasicInfo>) => Promise<void>) | null
>(null)
